import { Tabs } from 'antd';

import { PROJECT_MODE, PROJECT_TYPE_LABELS } from '@utils/constants';

const items = [PROJECT_MODE.ORTHOPHOTO, PROJECT_MODE.SINGLE_IMAGE].map(mode => ({
	key: mode,
	label: PROJECT_TYPE_LABELS[mode],
}));

/**
 * Controlled project-type filter, shown as tabs (Orthophoto / Single image). The parent
 * owns the active tab — usually via `useProjectTypeFilter`, which syncs it with the
 * URL `tab` param — so it stays the single source of truth for whatever the
 * page filters by it.
 *
 * @param {boolean} [props.disabled] - holds the tab, e.g. while a save for it is in flight
 */
const ProjectTypeFilter = ({ activeTab, onChange, disabled = false }) => (
	<Tabs
		items={disabled ? items.map(item => ({ ...item, disabled: true })) : items}
		activeKey={activeTab}
		onChange={onChange}
	/>
);

export default ProjectTypeFilter;
